<template>
  <div id="map">
  </div>
</template>

<script>
export default {
  data() {
    return {
      cacheMeta: "",
      cacheDpr: 1
    };
  },
  created() {},
  methods: {
    goback() {
      this.$router.go(-1);
    }
  },
  mounted() {
    let { log, lat } = this.$route.params;
    let map = new qq.maps.Map(document.getElementById("map"), {
      // 地图的中心地理坐标。
      center: new qq.maps.LatLng(lat, log),
      zoom: 80
    });
    let scaleControl = new qq.maps.ScaleControl({
      align: qq.maps.ALIGN.BOTTOM_LEFT,
      margin: qq.maps.Size(85, 15),
      map: map
    });
    let marker = new qq.maps.Marker({
      position: new qq.maps.LatLng(lat, log),
      map: map
    });

  }
};
</script>

<style lang="scss" scoped>
@import "./map.scss";
</style>



// WEBPACK FOOTER //
// map.vue?266dc2e2